module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common2.png"
    }
  })]), _c('p', {
    staticClass: "epip"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Such my woes, sorrow’s harvest,")])]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("She, day-bright, won’t let me rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Spellbinder, lovely goddess,")])]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Speaks to my ears magic, no less.")])]), _vm._v(" "), _c('p', {
    staticClass: "attc"
  }, [_vm._v("—DAFYDD AP GWILYM, “HIS AFFLICTION”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("R")]), _vm._v("hys stared hungrily after the woman named Juliana. “Tell me who she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forget about the girl, all right?” Morgan snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As Lettice said, she’s not for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coming from Morgan, that stung, and his friend was wrong anyway. Rhys could still feel her lips softening under his, could see her brilliant eyes grow dreamy at his words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But why would Miss Johnes and Morgan say such a thing? Wait—hadn’t Miss Johnes called Juliana “my lady”? Surely not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though that would explain why she was “not for him.” Servants didn’t speak cultured archaic Welsh, or know poetry or have such soft skin. She should have smelled of lye, not lavender. “She’s isn’t a servant, is she?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Morgan sighed. “Nay.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll make a nuisance of myself trying to find out who she is, if you don’t tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trust me, you don’t want to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For one thing, she’s English.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhys’s jaw dropped. “But she spoke beautiful Welsh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s fluent in it. From what Lettice says, she’s a bit of a bluestocking, and likes to read Welsh tales and such.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The blood rushed to Rhys’s head as he tried to remember if she’d had an accent. God, as if he could tell. English was his own native language. Father had always made them speak it at home. He’d learned Welsh from the servants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then something else Morgan said made his throat grow dry. “A bluestocking? How did a bluestocking come to be a friend of Miss Johnes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sigh, Morgan turned back toward his shop. “She’s Lettice’s mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mistress! ” A slow dread burned through him. “And her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morgan glanced at him with pity. “Lady Juliana St. Albans. Her father is the Earl of Northcliffe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feeling sick, Rhys stared at Morgan. Northcliffe had killed Father as surely as if he’d pushed him into the river himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he remembered how sweetly Juliana had encouraged him during the lecture. “I don’t believe you! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She followed Lettice here this eve, and Lettice didn’t send her home.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("God help them all. As he realized why the woman must ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("have sneaked into their meeting, Rhys tensed. “That little, conniving—”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here now, don’t talk that way about the lady. I understand why you’re upset, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lady?” Rhys whirled on him. “What was the ‘lady’ doing at a gathering like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just curious, I suppose. Lady Juliana does like Welsh things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By thunder, why didn’t you warn me who she was?” He felt like breaking something, like tearing into someone, anyone. Why did she have to be Northcliffe’s spawn?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you could badger her for her father’s crimes? Lettice would’ve cut out my tongue if I’d caused trouble for her mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her mistress could cause trouble for us! She could name our members to her father, and we’d all find ourselves hounded by the burgesses. You know how fond the press gangs are of carrying off radicals to serve in His Majesty’s Navy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wouldn’t turn us over,” Morgan protested, a bit nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She might do it for her father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think so. Besides, she’s only a girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nay.” Rhys thought of her soft body pressed to his. “Lady Juliana is not ‘only a girl.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps not, but you’re accusing her of being a spy.” Morgan laid a hand on his shoulder. “You’re thinking with your cock. She’s a pretty thing you can’t touch, so you’re taking that out on her.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Rhys recoiled from the truth in Morgan’s words. “Don’t ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("talk to me as if I’m some green lad. I know all about her family’s damnable tricks. Leave me be, and I’ll take care of this.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Morgan’s eyes narrowed. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s none of your concern.” Rhys stalked off, wanting to be away from Morgan and his too-sound logic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t do anything foolish, lad! ” Morgan called after him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhys kept heading for the river. “Damn, damn, damn. Not only English, but the earl’s own daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He could still hear her saying she wasn’t worthy of him. What stupid answer had he given? Ah yes, that he might not be worthy of her since she did honest labor. Hah! Her “honest labor” was sneaking about at night, spying on her father’s enemies, seducing them with her smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pounded his fist into his palm and tried to blot out her image, the intent expression she’d worn as he’d talked, the satiny texture of her cheek, her yielding lips—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn her for doing this to him! How could a woman look so innocent and be so deceitful?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And she’d certainly looked innocent. Not so much beautiful as arresting. The wide eyes and full mouth had seemed to signal a generosity of spirit, as well as an unconscious sensuality. She hadn’t flirted, hadn’t smiled coyly, and she’d kissed with an untutored wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His eyes narrowed. Obviously, he was more easily fooled by appearances than he’d thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now he’d reached the bridge. He strode along it, then stopped at the railing to stare into the swirling waters where his father had leapt to his death.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“May God have mercy on his soul.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Anguish hit Rhys anew. If only he’d been here a month ago, instead of racing back from Paris, summoned by an urgent letter from his father that read, “I lost Llynwydd, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why hadn’t he followed his instincts the first time Father suggested sending him away? He should have refused to leave. But Father had insisted that he acquire an “education befitting a gentleman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was all well and good for a boy who didn’t have to shore up the family estate at every turn, who hadn’t spent his holidays poring over Llynwydd’s books. Left to his own devices, Father had never been able to settle his mind to work, and he’d always relied too heavily on a land agent who overlooked his outrageous expenditures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So while Rhys had played the dutiful son in Paris, making stupid notes on French architecture and history and art by day, and meeting with philosophes at night, the damned Earl of Northcliffe had deceived his father into gambling away Rhys’s inheritance. While Rhys had been traveling back across the Channel, numb with shock from his father’s letter after it finally reached him, his father had been throwing himself into the Towy. Rhys had arrived just in time to watch them pull the body from the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Father,” he said, looking down into the unforgiving waters, “I’m a squire now. What good is my proper education to either of us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whistling wind was his only answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared out into the unfeeling night. “But I’m going to make it right. You’ll see.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("He’d already been to a solicitor about the possibility of regaining Llynwydd. The man claimed Rhys had a chance of winning a dispute over the property, since his father had not been “in his right mind” when he’d signed it over to the earl, and since there were rumors that the earl had cheated. The solicitor and his agents had been gathering facts for the case, having already notified the earl that Rhys was disputing the transfer of ownership.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But apparently Lord Northcliffe had his own methods for stopping Rhys—like sending his daughter to the Sons of Wales meeting, where she could take note of every radical in the place. Such knowledge would be useful to a man known for intimidation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, Rhys would put a stop to that. He’d go to Northcliffe Hall and set the damned earl straight before this spying business went any further. And if Lady Juliana was there, he’d set her straight, too.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The next morning, Juliana sat in the breakfast room, swirling her spoon in her hot chocolate. How "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("wonderful")]), _vm._v(" Mr. Vaughan had been, so learned, so . . . fiery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lettice had spouted nonsense about how a man would say anything to get a woman in his clutches, but Mr. Vaughan wasn’t like that. He was passionate, like her, and couldn’t contain his feelings about things that mattered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was still staring dreamily into space when the sound of loud voices in the foyer jerked her from her reverie. Wondering who would call so early, she rose and went out into the hall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“I don’t care what time it is,” said a familiar voice. “I want to see his lordship immediately! ”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She froze beside the staircase. Though her view of the foyer was blocked, she recognized those ringing tones from last night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door to Papa’s study opened from the other side of the staircase and, oblivious to her lurking in the shadows, he stormed into the hall. She crept forward, her heart in her throat as she peered around the edge to see her father come face-to-face with Mr. Vaughan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two footmen were attempting to reason with Mr. Vaughan, but he was standing firm. He looked exactly as she’d remembered him—all lean muscle animated with a vibrant energy that put the spark in his eyes and the glow on his face. Why on earth was he here?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father glowered at him. “What is the meaning of this, sir? You cannot force your way into a man’s house without—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am the son of the man you ruined,” Mr. Vaughan said. “William Vaughan was my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father gestured to the footmen, who returned to their posts. Then he turned his hard-eyed gaze on Mr. Vaughan. “I heard you’d returned to town.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure you did. If none of your other spies told you, then I suppose you heard it from your daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juliana’s knees buckled. So he’d found out who she was. But why tell Papa that he knew her? Didn’t he know what trouble he’d get her into?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean, my daughter?” Papa demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t pretend you didn’t send her to spy on me and my friends last night.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“Last night?”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Vaughan thought her a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("spy")]), _vm._v("? What happened to all his sweet words? And his gentle kiss?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I should have expected this of you,” Mr. Vaughan went on. “You couldn’t allow the wheels of justice to take their slow turn. No, you had to skulk behind your daughter’s skirts, sending her out to do your dirty work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How dared he! She’d obviously been quite wrong about his nobility of mind. He was beastly, simply beastly! If she were a man, she’d walk right out and thrash him!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she could only watch helplessly as her father drew himself up, a vein bulging in his forehead. “You, sir, are insane if you think my daughter would involve herself with your band of ruffians! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("You tell him!")]), _vm._v(" Perhaps Papa would refuse to believe Mr. Vaughan’s words. Perhaps he’d dismiss them as troublemaking nonsense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Vaughan dashed those hopes. “Your daughter’s name is Juliana, is it not?” Then he proceeded to describe her with an accuracy as astonishing as it was damning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juliana buried her face in her hands as her father sputtered, then shouted, “Juliana! Juliana, girl, you come down here at once! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How could she face Papa’s temper, especially in front of that betraying wretch? Yet she must defend herself. Not that Papa would listen to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She could cheerfully throttle Mr. Vaughan. The wicked creature obviously didn’t care that he was ruining her life.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“Don’t take it out on the poor girl,” Mr. Vaughan said, ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("and for a moment, Juliana thought him repentant. “ ’Tisn’t her fault that she isn’t as practiced at deceit as her father.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The urge to throttle him surged again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Juliana! ” Her father’s tone brooked no argument as he started for the stairs. He’d keep at it until the entire household had come to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sigh, she emerged from behind the staircase. “Here I am, Papa.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taking her by the arm, he dragged her in front of Mr. Vaughan. “Tell me truthfully, girl: Do you know this man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She considered lying, but that might force Mr. Vaughan to elaborate on her adventure. “Aye, Papa.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father’s hand tightened painfully on her. “Is he telling the truth? Were you at this gathering of his friends last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cast a glance at Mr. Vaughan, whose face was stony and remote as he stared at her without a whit of concern. Any guilt she’d felt for misleading him last night rapidly dissipated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you?” Papa repeated, shaking her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lifting her chin in defiance of them both, she said, “Aye.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father shoved her away. “Go wait for me in the study. I’ll be there presently to administer your punishment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tremor of fear skittered along her spine. “Please, Papa, let me explain—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go to my study! ” He shook his thick finger in that direction. “Now, or I’ll cane you thrice as hard! ”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("With a shudder, she backed away. She’d seen Papa angry before, but not like this. Still, she mustn’t let him reduce her to a quivering puddle, or it would go worse for ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("her. With all the dignity she could muster, she stalked off to the study.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhys watched her go, uneasiness settling in his gut. What in the devil was this? An elaborate show for his benefit? Surely the earl wouldn’t cane his daughter for this, would he? She’d done only what he’d put her up to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she’d been caught. Perhaps her punishment was for that. A surge of unwarranted pity made Rhys tighten his fists. “You shouldn’t punish Juliana for merely carrying out your orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The earl remained silent until the study door opened and closed. Then he fixed Rhys with a cold gaze. “I assure you, sir, I wouldn’t send my daughter within ten miles of you and your scoundrel friends. If I needed spies, I’d use one of my sons or a servant. I’d not send an innocent girl into a nest of vipers, even to crush the likes of you! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The logic behind the man’s words struck Rhys hard. If the earl spoke the truth—and somewhere in the fog of Rhys’s anger it seemed plausible—then Juliana was about to receive a caning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it was all his fault.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that thought, he snapped, “If she didn’t go at your request, then why in God’s name was she there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Northcliffe’s eyes narrowed. “I have no idea. The girl has strange notions about the Welsh, to be sure, but I’d never thought to see her sneaking about at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A chill shook Rhys. Morgan had said she liked to dabble in Welsh things, and he hadn’t seemed concerned about her presence at the meeting. Had Rhys jumped to conclusions?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“Your ‘wheels of justice’ don’t worry me,” Northcliffe went on. “I acquired Llynwydd fairly, and I’ll hold what is mine, no matter what some upstart Welshman thinks to do about it! ”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t ‘acquire’ that estate. You stole it. And I intend to prove it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They glared at each other a long moment, hatred boiling up between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We shall see, my boy.” Northcliffe summoned his footmen, then motioned to Rhys. “Escort Mr. Vaughan to the gate. I never want to see his scurrilous face in this house again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhys smiled grimly. “I can see myself out. And don’t worry, Northcliffe. I shan’t set foot here again until you resign your claim to Llynwydd. Which you will do one day, if I have anything to say about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ignoring the earl’s derisive snort, he left, with the footmen trailing after him. But as soon as Rhys passed through the wrought-iron gates and heard them clank shut behind him, he paused to stare back through the bars, his anger replaced by a more unsettling emotion. Guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juliana was in there awaiting a caning. If she truly had attended the meeting for her own reasons, then she was suffering due to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Belatedly, he remembered her flawless command of Welsh and her quoting of Welsh poetry. Today she’d worn an expensive blue satin gown, but the undersides of her cuffs had been as dingy as his from having well-inked paper rub against them. She was clearly a scholar. And scholars were rarely spies.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("“Damn it all! ” He moved along the stone wall, searching for a way to get back in.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It wasn’t as if he could do anything. He couldn’t leap into the earl’s study and whisk Juliana away. But he also couldn’t let her be caned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps he could create a distraction to get her father away from her. Or find her afterward and soothe her hurts. Beg her forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he came to an oak branch that extended several feet over the wall, he decided he could probably reach it. Then he could climb up the wall and jump over—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A rustling on the other side gave him pause. The sound seemed to move up the oak. Puzzled, he stared up into the tree. When he caught a glimpse of blue satin, relief surged through him. He should have known Lady Juliana wouldn’t stay to be beaten. Running away seemed to be her specialty, thank God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More satin spilled over the top of the wall as she crept backward along the branch. He saw a flash of shapely calf before her silk hose caught on the bark. She grabbed at it, but her hair, a rich coppery red that had been hidden from his sight last night, masked her face and blinded her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He moved under the branch just as she lost her balance and fell right into his arms. Clearly startled, she shoved her hair from her face, but when she saw who’d caught her, she scrambled out of his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you doing here?” she demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Catching you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? So you could make sure I got my caning? Are you planning to march me back in to Papa?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("He winced. If he hadn’t already been convinced she was innocent, her wounded tone and attempt at escape would have done it. “Nay. I thought I’d rescue you, instead.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She brushed leaves and twigs from her gown. “I am doing fine rescuing myself, thank you very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you planning to do—hide?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that it’s any of your concern, but yes. Until Mama can talk Papa out of my punishment. Or at least get it reduced.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That works?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes.” Her stiff look sent guilt spiraling through him. “I had to do something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks to me and my blundering.” He tugged an acorn from her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when he couldn’t resist letting his fingers linger over the silken strands, she swatted his hand away. “How dare you! First, you get me in trouble, and then you act as if it never happened! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her words lacerated his already beaten conscience. “What I did this morning was unconscionable, and I am sorry. I can say nothing in my defense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The throaty timbre of her voice made him ache to touch her again, but he knew better than to try. “You must understand—your father and his candidate for Member of Parliament are persecutors of radicals. When I found out you were his daughter—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You decided I was his "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("spy")]), _vm._v(". I understand quite well, you . . . you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("diawl")]), _vm._v("! ”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Her use of the Welsh word for “devil” took him off ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("guard. As she flounced off toward the woods, he hastened after her.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ignored my obvious sympathy for your cause and for you,” she said, “and instead imagined horrid things of me. I know Papa committed a great wrong against your family. But I had naught to do with it! ” She stomped through the grass, heedless of how it ruined her skirts. “But because I am a St. Albans, you decided I was in it up to my neck.” She halted to fix him with a piercing stare. “Correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something like that,” he muttered, irritated that she had so succinctly described his mad thoughts over the last night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you came to Papa with your suspicions, instead of to me.” Her voice caught. “Even though last night you praised my eyes and quoted Huw Morus to me. You told me . . . Oh, it doesn’t matter what you told me. All of it was lies anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not so! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye.” She eyed him as if he were a snail. “Lettice explained it to me. A man will say anything to pull down a woman’s defenses, so he can get at her person.” Her sweet mouth trembled, and he felt like a bastard all over again. “You said all those lovely things to get me to kiss you, yet it meant nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not true. I meant every word.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he reached for her, she backed away. “If you lay a hand on me, I’ll call the footmen.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("“And let them carry you back to your father?” As she blanched, he caught her hand. “Please, Juliana, you must ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("believe me. This morning was a temporary madness. Last night when I met you, I realized I’d met my ideal woman. Then I discovered you were out of my reach. It infuriated me to have you snatched from my hands before I’d had a chance to know you. That’s why I struck out today.”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Against me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nay, against everything that took you from me. Unfortunately, that included you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cocked her head. “You’re speaking in riddles and trying to confuse me.” She tried to snatch her hand from his.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wouldn’t let go. “I know this sounds insane, but from the moment I saw you smile at me, I wanted to know everything about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pressed her lips together. “Your pretty words won’t work this time. I know your game now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn it all, why did he want so badly to convince her he wasn’t an ogre? He ought to be running as fast and far away as he could. Lettice was right—she wasn’t for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet something in him rebelled at the idea. He clasped her hand against his heart. “What can I do to change your mind, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("anwylyd")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t call me that. I’m not your ‘darling.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But he could see her wavering. “Tell me how to make up for my poor behavior. I can’t take your caning for you, but I could tell your father I was mistaken, that I saw some other woman at the meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She snorted. “Too late for that.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Clasping her about the waist, he drew her close. “Doesn’t it mean something to you that I came back to rescue you? ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Don’t my apologies mean anything? That’s why I was under that tree: I was going to pull myself up on that branch and go after you.”")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He bent close, and she sucked in her breath. He wanted to taste her again, to crush her mouth under his, to revel in its warmth. Her lavender scent filled his nostrils, driving him more insane. He pressed a kiss into her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, you mustn’t—” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Touch you? Kiss you? I truly can’t help myself when I’m with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glancing back at the estate walls, she stiffened. “Oh no—Papa has sent my brothers looking for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two burly young men were indeed coming round the corner of the wall. He recognized Viscount Blackwood, the earl’s heir. Swiftly Rhys pulled her into the forest, praying that the men hadn’t seen them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when he tried to drag her deeper, she halted. “Please, I must go back. They won’t rest until they find me, and if they find you with me, ’twill be very bad for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to protect you. You shouldn’t suffer for my error—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter. I can endure the caning, now that I know—” She broke off, coloring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?” Lifting her hand to his lips, he pressed a kiss into her palm. “Now that you know what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ducked her head shyly. “That you no longer believe those awful things you said. That you didn’t lie last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t. And I didn’t.” He stroked her hair. “Do you forgive me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("That sent his blood thundering through his veins. He didn’t deserve her kindness or trust. He shouldn’t desire her, or let her desire him. Yet he did, and he would.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He held her close. “Stay awhile.” He managed a smile. “Give your mother time to plead on your behalf.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cupped his cheek, looking as if she might do as he asked. But just then one of her brothers called out, “Darcy, I see something over there . . . in the woods! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pushed him away hard. “Go! ” When he hesitated, her voice turned pleading. “If you care for me at all, run and don’t come back. Because if they find me with you, I’ll be caned within an inch of my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only that gave him the strength to flee into the woods. But he halted a short distance away and hid to watch as her brothers caught up with her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Juliana, you little fool, you’re in big trouble now,” said the viscount. “Father will have your hide for running off! ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could tell him you couldn’t find me,” Juliana said hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her brother shook his head. “This isn’t like when you were a girl and I hid you from Father. If you don’t come now, ’twill be worse for you later. So it’s better to get it over with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the man’s sympathetic tone, Rhys had to fight the urge to jump out and snatch her from her brothers. But thrashing her brothers would only get her in more trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By thunder, this was a damned mess! He shouldn’t have come at all. And he certainly shouldn’t have held her again, allowing her to steal once more into his heart.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Look at me, lurking behind trees, longing after an Englishwoman, and one beyond my station at that. She ought to hate me. I ought to hate her.")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet he didn’t. And given the chance, he would see her again. That was what worried him most.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 84
// module chunks = 0